import {Component, Input, Output, EventEmitter} from '@angular/core';
import {Donation} from "../donation/donation";
import { OptionService } from "../option/option.service";
import {DecimalPipe} from "@angular/common";


@Component({
    selector: 'banktransfer',
    templateUrl: './output.banktransfer.component.html',
    providers: [DecimalPipe]
})
export class BanktransferComponent {
    /**
     * the current donation
     */
    @Input() donation: Donation;

    /**
     * Current step of the application
     */
    @Input() step: string;

    /**
     * Output for changing the step
     * @type {EventEmitter}
     */
    @Output() stepChange: EventEmitter<any> = new EventEmitter();

    /**
     * Constructor
     * @param optionService
     * @param decimalPipe
     */
    constructor(
        private optionService: OptionService, 
        protected decimalPipe: DecimalPipe
    ) {}

    /**
     * Shows the data for the bank
     */
    showData(): void {
        this.step = "banktransfer";
        this.stepChange.emit(this.step);
    }

    /**
     * Returns the URL for the QR Code
     * @returns {string|boolean}
     */
    getQrCodeURL(): any {
        if(this.donation.paymentBanktransfer.receiverName) {
            let url = this.optionService.getQrCodeUrl();
            url = url.replace(/receiver/, this.donation.paymentBanktransfer.receiverName);
            url = url.replace(/iban/, this.donation.paymentBanktransfer.receiverIban);
            url = url.replace(/bic/, this.donation.paymentBanktransfer.receiverBic);
            url = url.replace(/subject/, this.donation.paymentBanktransfer.paymentReferenceMessage);
            url = url.replace(/amount/, this.donation.amount);

            return url;
        }
        return false;
    }

    /**
     * Returns a formatted string of the IBAN
     * @returns {string}
     */
    getFormattedIBAN(): string {
        return this.donation.paymentBanktransfer.receiverIban.replace(/ /g, "<span class='space'></span>");
    }

    /**
     * retursn the amount that should be credited as string
     */
    getAmount(): string {
        const total = this.donation.amount + this.donation.extraAmount;
        const hasDecimals = total % 1 !== 0;
        
        return this.decimalPipe.transform(total, hasDecimals ? '1.2-2' : '1.0-0');
    }
}
